if (!customElements.get('grumplets-size-switch')) {
  customElements.define('grumplets-size-switch', class extends HTMLElement {
    connectedCallback() {
      this.map = JSON.parse(this.dataset.map);
      this.unit = 'US';
try { this.unit = localStorage.getItem('grumplets-size-unit') === 'EU' ? 'EU' : 'US'; } catch {}
      this.onClick = (event) => {
        const button = event.target.closest('button[data-unit]');
        if (!button || !this.contains(button)) return;
        this.unit = button.dataset.unit;
        try { localStorage.setItem('grumplets-size-unit', this.unit); } catch {}
        document.querySelectorAll('grumplets-size-switch').forEach((picker) => {
          picker.unit = this.unit;
          picker.refresh();
        });
      };
      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(() => this.refresh());
      this.observer.observe(this, { childList: true, subtree: true });
      this.refresh();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
    }
    refresh() {
      const controls = this.querySelector('.grumplets-size-units');
      if (!controls) return;
      const inputName = this.dataset.optionName + '-' + this.dataset.position;
      const radios = [...this.querySelectorAll('variant-selects input[type="radio"]')].filter(input => input.name.trim() === inputName);
      const select = [...this.querySelectorAll('variant-selects select')].find(input => input.name === 'options[' + this.dataset.optionName + ']');
      const values = radios.length ? radios.map(input => input.value) : [...(select?.options || [])].map(option => option.value);
      const supported = values.length > 0 && values.every(value => this.map[value]);
      controls.hidden = !supported;
      if (!supported) return;
      controls.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.unit === this.unit)));
      for (const input of radios) {
        const label = [...this.querySelectorAll('label')].find(label => label.htmlFor === input.id);
        if (!label) continue;
        const textNode = [...label.childNodes].find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        if (!textNode) continue;
        const value = this.unit === 'US' ? this.map[input.value] : input.value;
        const next = ' ' + value + ' ';
        if (textNode.textContent !== next) textNode.textContent = next;
        label.title = 'EU ' + input.value + ' / US ≈ ' + this.map[input.value];
      }
      if (select) for (const option of select.options) {
        if (!option.dataset.euLabel) option.dataset.euLabel = option.textContent;
        const next = this.unit === 'US' ? option.dataset.euLabel.replace(option.value, this.map[option.value]) : option.dataset.euLabel;
        if (option.textContent !== next) option.textContent = next;
      }
    }
  });
  const style = document.createElement('style');
  style.textContent = 'grumplets-size-switch{display:block}.grumplets-size-units:not([hidden]){display:flex;gap:0;margin:0 0 12px;width:fit-content;border:1px solid #6b655f;border-radius:4px;overflow:hidden}.grumplets-size-units button{font:inherit;cursor:pointer;border:0;background:#fffdf8;color:#211f1c;min-width:56px;min-height:44px;padding:8px 16px}.grumplets-size-units button[aria-pressed="true"]{background:#211f1c;color:#fffdf8}.grumplets-size-units button:focus-visible{outline:2px solid #b62c33;outline-offset:-4px}';
  document.head.appendChild(style);
}
